module.exports = __webpack_public_path__ + "static/media/desktop.7574f734.mp4";